module.exports = __webpack_public_path__ + "img/weebly.2bc111ed.svg";